'use client';

import { useLocale } from 'next-intl';

import PreviousTermsAndConditions from './PreviousTermsAndConditions';

const Content = () => {
  const selectedLocale = useLocale();

  return <PreviousTermsAndConditions locale={selectedLocale} />;
};

export default Content;
